/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Intro_BodyInputs */

const es_home_intro_body = /** @type {(inputs: Home_Intro_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata es una plataforma de conocimiento empresarial diseñada para resolver la fragmentación de información que sufren las empresas modernas.`)
};

const en_home_intro_body = /** @type {(inputs: Home_Intro_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata is an enterprise knowledge platform designed to solve the information fragmentation that modern businesses suffer from.`)
};

/**
* | output |
* | --- |
* | "Nexata is an enterprise knowledge platform designed to solve the information fragmentation that modern businesses suffer from." |
*
* @param {Home_Intro_BodyInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_intro_body = /** @type {((inputs?: Home_Intro_BodyInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Intro_BodyInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_intro_body(inputs)
	return en_home_intro_body(inputs)
});
export { home_intro_body as "home.intro.body" }